import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StateService } from '@uirouter/core';
import { CurrentPlanService } from 'src/app/components/plans/current-plan.service';

export interface AiCreditsModalData {
  canModifyPlan: boolean;
  hasPlan: boolean;
}

@Component({
  selector: 'ai-credits-modal',
  templateUrl: './ai-credits-modal.component.html',
  styleUrl: './ai-credits-modal.component.scss',
  standalone: false,
})
export class AiCreditsModalComponent {
  constructor(
    public dialogRef: MatDialogRef<AiCreditsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AiCreditsModalData,
    private currentPlanService: CurrentPlanService,
    private stateService: StateService,
  ) {}

  seePlans(): void {
    this.dialogRef.close();
    this.currentPlanService.showPurchaseOptions();
  }

  purchaseCredits(): void {
    this.dialogRef.close();
    this.stateService.go('apps.purchase.add-on.ai-credits');
  }

  close(): void {
    this.dialogRef.close();
  }
}
